<div class="row">

    <div class="col-sm-12 col-md-6 col-12">
        <div class="card dash-card">
            <div class="row">
                <div class="col-sm-6 col-md-12 col-lg-4 col-xl-4">
                    <div class="card card-dashh">
                        <div class="box1 cursor-pointer">
                            <div class="row">
                                <div class="col-sm-6 col-md-8 col-lg-8 col-xl-8 col-8">

                                </div>
                                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 col-4 d-flex align-items-center">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-12 col-lg-4 col-xl-4">
                    <div class="card card-dashh">
                        <div class="box2 cursor-pointer">
                            <div class="row">
                                <div class="col-sm-6 col-md-8 col-lg-8 col-xl-8 col-8">

                                </div>
                                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 col-4 d-flex align-items-center">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-12 col-lg-4 col-xl-4">
                    <div class="card card-dashh">
                        <div class="box3 cursor-pointer">
                            <div class="row">
                                <div class="col-sm-6 col-md-8 col-lg-8 col-xl-8 col-8">

                                </div>
                                <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4 col-4 d-flex align-items-center">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-6 col-12">
        <div class="card dash-card">
            <div class="row">
                <div class="col-sm-6 col-md-12 col-lg-6 col-xl-6">
                    <div class="card card-dashh">
                        <div class="box4 cursor-pointer">
                            <div class="row">
                                <div class="col-sm-6 col-md-8 col-lg-9 col-xl-9 col-8">

                                </div>
                                <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3 col-4 d-flex align-items-center">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-12 col-lg-6 col-xl-6">
                    <div class="card card-dashh">
                        <div class="box5 cursor-pointer">
                            <div class="row">
                                <div class="col-sm-6 col-md-8 col-lg-9 col-xl-9 col-8">

                                </div>
                                <div class="col-sm-6 col-md-4 col-lg-3 col-xl-3 col-4 d-flex align-items-center">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-12 col-md-12 col-lg-6 col-12">
        <div class="card ride-card">
            <div class="box-ride cursor-pointer">

            </div>
            <div class="d-flex align-items-center">
                <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_54_7125)">
                        <rect x="6" y="2" width="45" height="45" rx="12" fill="#83BE41" />
                    </g>

                </svg>
            </div>
        </div>
        <div class="card ride-card">
            <div class="box-ride cursor-pointer">

            </div>
            <div class="d-flex align-items-center">
                <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_54_7133)">
                        <rect x="6" y="2" width="45" height="45" rx="12" fill="#83BE41" />
                    </g>

                </svg>
            </div>
        </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 col-12">
        <div class="card income-card">
            <div class="box-income cursor-pointer">

            </div>

        </div>
    </div>
</div>